<template>
  <tr class="table-row-container" @click="clickItem()">
    <td><div class="title">{{title}}</div></td>
    <td class="role">{{humanReadableRole}}</td>
    <td>{{humanReadableStatus}}</td>
    <td class="date">{{formatDate(startDate)}}</td>
    <td class="date">{{formatDate(endDate)}}</td>
    <td class="actions">
      <font-awesome-icon :icon="['fa', 'pencil-alt']" v-if="canEdit"
        @click.stop="$router.push(`/event/${id}/edit/overview`)"></font-awesome-icon>
      <font-awesome-icon :icon="['fa', 'minus-circle']" v-if="canDelete"
        @click.stop="deleteItem()"></font-awesome-icon>
      <font-awesome-icon :icon="['fa', 'clone']" v-if="canDuplicate"
        @click.stop="duplicateItem()"></font-awesome-icon>
    </td>
  </tr>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import flatpickr from 'flatpickr';

export default {
  name: 'my-event-item',
  props: {
    id: {
      type: String,
    },
    title: {
      type: String,
    },
    startDate: {
      type: Number,
    },
    endDate: {
      type: Number,
    },
    role: {
      type: String,
    },
    status: {
      type: String,
    },
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
    ...mapGetters('sponsorshipEvent', ['canEditEvent', 'canDeleteEvent', 'canDuplicateEvent']),
    ...mapState('sponsorshipEvent', ['allRoles', 'allStatuses']),
    canEdit() {
      return this.canEditEvent(this.$props.role, this.$props.status);
    },
    canDelete() {
      return this.canDeleteEvent(this.$props.role, this.$props.status);
    },
    canDuplicate() {
      return this.canDuplicateEvent(this.$props.role);
    },
    humanReadableStatus() {
      const statusObject = this.allStatuses.find(status => status.key === this.$props.status);
      return statusObject ? statusObject.value : '-';
    },
    humanReadableRole() {
      const roleObject = this.allRoles.find(role => role.key === this.$props.role);
      return roleObject ? roleObject.value : '-';
    },
    isPendingApproval() {
      return this.$props.status === 'pending_approval';
    },
  },
  methods: {
    ...mapActions('utils', ['setIsMouseDisabled']),
    formatDate(utc, format = 'Y-m-d') {
      return flatpickr.formatDate(new Date(utc), format);
    },
    deleteItem() {
      this.setIsMouseDisabled(true);
      this.$toasted.show('Are you sure you want to delete this event', {
        type: 'info',
        duration: 0,
        action: [{
          text: 'Yes',
          onClick: async (e, t) => {
            await this.backendAxios
              .delete(`/sponsorship-event/my-event/id/${this.$props.id}`);
            this.$emit('change');
            t.goAway(0);
            this.setIsMouseDisabled(false);
          },
        }, {
          text: 'No',
          onClick: (e, t) => {
            t.goAway(0);
            this.setIsMouseDisabled(false);
          },
        }],
      });
    },
    async duplicateItem() {
      try {
        await this.backendAxios
          .post(`/sponsorship-event/my-event/id/${this.$props.id}`);
        this.$emit('change');
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },
    clickItem() {
      if (this.canEdit || this.isPendingApproval) {
        this.$router.push(`/event/${this.id}/edit/preview`);
      } else {
        this.$router.push(`/event/${this.id}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.table-row-container {
  width: 45rem;
  text-align: left;
  height: 3rem;
}

.table-row-container:hover {
  background-color: #efefef99;
  cursor: pointer;
}

.actions  {
  display: flex;
  max-width: 8rem;
  justify-content: flex-start;
  align-items: center;
  height: 2rem;
}

a {
  color: black;
  text-decoration: none;
}

a:hover, .actions svg:hover {
  color: $action-hover-color;
}

.actions svg {
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 0.1rem;
  color: #444444;
  background-color: $action-bg-color;
}

td {
  padding: 0.5rem 0.5rem 0 0.5rem;
  color: #444444;
}

.title {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media screen and (max-width: 1024px) {
  .title {
    max-width: 10rem;
  }
}

@media screen and (max-width: 768px) {
  .date {
    display: none
  }

  .title {
    max-width: 5rem;
  }
}

@media screen and (max-width: 823px) {
  .date {
    display: none
  }
}

@media screen and (max-width: 350px) {
  .role {
    display: none
  }
}

</style>
